module.exports = __webpack_public_path__ + "img/f2b6dd8bbdf78983bcd230df155491eb.f2b6dd8b.png";